import { render, staticRenderFns } from "./StatusLive.vue?vue&type=template&id=37b9d4a0&scoped=true"
import script from "./StatusLive.vue?vue&type=script&lang=js"
export * from "./StatusLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9d4a0",
  null
  
)

export default component.exports